import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermValue } from '../../../packages/JsonQuery';
import { EMetroTravelType } from '../../../packages/api-models/common/json_query';

export const selectTravelType = createSelector(
  selectJsonQuery,
  jsonQuery => getTermValue('only_foot')(jsonQuery) || EMetroTravelType.Any,
);
